var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0749 10.8333H7.76654L11.8332 14.8999C12.1582 15.2249 12.1582 15.7583 11.8332 16.0833C11.5082 16.4083 10.9832 16.4083 10.6582 16.0833L5.16654 10.5916C4.84153 10.2666 4.84153 9.7416 5.16654 9.4166L10.6499 3.9166C10.9749 3.5916 11.4999 3.5916 11.8249 3.9166C12.1499 4.2416 12.1499 4.7666 11.8249 5.0916L7.76654 9.1666H17.0749C17.5332 9.1666 17.9082 9.5416 17.9082 9.99994C17.9082 10.4583 17.5332 10.8333 17.0749 10.8333Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.66667,
    height: 12.3981,
    rx: 0.833334,
    transform: "matrix(-1 0 0 1 3.75879 3.80078)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPage);
export default __webpack_public_path__ + "static/media/first-page.ffae04888b7b8d737f29a546efb2d286.svg";
export { ForwardRef as ReactComponent };